import { forwardRef } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import {
  DROPDOWN_MENU_ITEM_INDICATOR_ICON,
  DROPDOWN_MENU_ITEM_VARIANT_CLASS_MAP,
  type TDropdownMenuCheckboxItemElement,
  type TDropdownMenuCheckboxItemProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const DropdownMenuCheckboxItem = forwardRef<TDropdownMenuCheckboxItemElement, TDropdownMenuCheckboxItemProps>(
  (
    {
      children,
      className,
      icon,
      variant = "default",
      ...props
    },
    ref,
  ) => (
    <DropdownMenuPrimitive.CheckboxItem
      data-component="DropdownMenuCheckboxItem"
      ref={ref}
      className={cn(
        "relative flex w-full cursor-default select-none items-center gap-2 rounded-sys-sm py-1.5 pl-8 pr-2 outline-none transition-colors",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        DROPDOWN_MENU_ITEM_VARIANT_CLASS_MAP[variant],
        className,
      )}
      {...props}
    >
      <span
        data-component="DropdownMenuCheckboxItemIndicator"
        className="absolute left-2 flex h-4 w-4 items-center justify-center"
      >
        <DropdownMenuPrimitive.ItemIndicator>
          <Icon
            icon={icon ?? DROPDOWN_MENU_ITEM_INDICATOR_ICON}
            aria-hidden="true"
            size="sm"
          />
        </DropdownMenuPrimitive.ItemIndicator>
      </span>
      <TextBody tag="span" size={3} color="inherit" isResponsive={false}>
        { children }
      </TextBody>
    </DropdownMenuPrimitive.CheckboxItem>
  ),
);

DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
